// Mobile Drawer Toggle
function toggleMobileDrawer() {
	document
		.getElementsByClassName("MobileMenuToggle2")[0]
		.classList.toggle("is-active");
	document.getElementsByClassName("NavList")[0].classList.toggle("is-active");
}

// Header sticky on scroll
let scrollpos = window.scrollY;

const header = document.querySelector("header .Navigation");
const scrollChange = 1;

const add_class_on_scroll = () => header.classList.add("large-navigation");
const remove_class_on_scroll = () =>
	header.classList.remove("large-navigation");

window.addEventListener("scroll", function () {
	scrollpos = window.scrollY;

	if (scrollpos >= scrollChange) {
		remove_class_on_scroll();
	} else {
		add_class_on_scroll();
	}
});

// Custom Popup
window.addEventListener("load", function () {

	// if query string contains ?test-custom-popup=true, show the popup
	const urlParams = new URLSearchParams(window.location.search);
	const testCustomPopup = urlParams.get("test-custom-popup");
	if (testCustomPopup) {
		showCustomPopup();
		return;
	}

	const now = new Date().getTime();
	const endDate = new Date("Oct 10, 2023 00:00:00").getTime();
	if (new Date().getTime() > endDate) {
		return;
	}

	// display the popup max every 3 days
	const lastClosed = localStorage.getItem("custom-popup-closed");

	if (!lastClosed) {
		showCustomPopup();
		return;
	}

	const diff = now - parseInt(lastClosed);
	const days = diff / (1000 * 60 * 60 * 24);

 	if (days > 3) {
		showCustomPopup();
	}
});

const hideCustomPopup = () => {
	const now = new Date().getTime();
	localStorage.setItem("custom-popup-closed", now);
	localStorage.setItem("custom-popup-last-action", "close");
	document.getElementById("custom-popup").classList.remove("active");
};

const showCustomPopup = () => {
	document.getElementById("custom-popup").classList.add("active");
};

const customPopupNavigate = (type) => {
	// type can be WHITE or BLACK
	// black => https://shop.hacksawgaming.com/products/chaos-crew-ii-black-hoodie
	// white => https://shop.hacksawgaming.com/products/chaos-crew-ii-white-hoodie

	const now = new Date().getTime();
	localStorage.setItem("custom-popup-closed", now);
	localStorage.setItem("custom-popup-last-action", type);

	if (type === "black") {
		window.location.href = "https://shop.hacksawgaming.com/products/chaos-crew-ii-black-hoodie";
	} else {
		window.location.href = "https://shop.hacksawgaming.com/products/chaos-crew-ii-white-hoodie";
	}
};
